import React, { useState, useEffect } from "react";
import { Card, Table, Badge } from "react-bootstrap";
import Content from "../../../Components/Dashboard/Content/Content";
import { User_Profile } from "../../../ReduxStore/Slice/Common/commoSlice.jsx";
import { useDispatch } from "react-redux";
import Delta from "./delta.jsx";
import Coindcx from "./coindcx.jsx";
import Binance from "./Binance.jsx";
import Zebpay from "./Zebpay.jsx";
import CoinSwitch from "./CoinSwitch.jsx";
import Pi42 from "./Pi42.jsx";


const Wallet = () => {
  const dispatch = useDispatch();
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const gotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const UserNamego_localstg = JSON.parse(
    localStorage.getItem("user_details_goTo")
  );

  const [tradingStatus, setTradingStatus] = useState("0");
  const [broker, setBroker] = useState("0");

  useEffect(() => {
    getUserProfile();
  }, []);

  const getUserProfile = async () => {
    try {
      const userId = gotodashboard
        ? UserNamego_localstg.user_id
        : user_details.user_id;
      const token = gotodashboard
        ? UserNamego_localstg.token
        : user_details.token;
      const response = await dispatch(
        User_Profile({
          id: userId,
          token: token,
        })
      ).unwrap();

      if (response.status) {
        setTradingStatus(response.data[0].TradingStatus);
        setBroker(response.data[0].broker);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  return (
    <Content Page_title="Wallet" button_status={false}>
      {tradingStatus == 1 ? (
        broker === "2" ? (
          <Delta />
        ) : broker === "1" ? (
          <Coindcx />
        ) : broker === "3" ? (
          <Binance />
        ) : broker === "4" ? (
          <Zebpay />
        ) : broker === "5" ? (
          <CoinSwitch />
        ) : broker === "6" ? (
          <Pi42 />
        ) : (
          <Card className="shadow-sm p-4">
            <h5 className="text-center text-danger">
              Trading is currently disabled for your account.
            </h5>
            <p className="text-center">
              Please contact support for more information.
            </p>
          </Card>
        )
      ) : (
        <Card className="shadow-sm p-4">
          <h5 className="text-center text-danger">
            Trading is currently disabled for your account.
          </h5>
          <p className="text-center">
            Please contact support for more information.
          </p>
        </Card>
      )}

    </Content>
  );
};

export default Wallet;
